import React, { useEffect, useState } from 'react';
import { getSgsstDashboard } from '../services/api';
import SgsstTabs from '../components/SgsstTabs';

const MESES = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
const yNow = new Date().getFullYear();

export default function SgsstDashboard() {
  const [anio, setAnio] = useState(yNow);
  const [d, setD] = useState(null);

  useEffect(() => { getSgsstDashboard(anio).then(r => setD(r.data)).catch(() => setD(null)); }, [anio]);

  const t = d?.totales || {};
  const ind = d?.indicadores || {};
  const acc = d?.acciones || {};
  const rie = d?.riesgos || {};
  const op = d?.operacion || {};
  const maxMes = Math.max(1, ...(d?.por_mes || []).map(m => m.accidentes + m.incidentes));
  const mesData = MESES.map((_, i) => (d?.por_mes || []).find(m => m.mes === i + 1) || { accidentes: 0, incidentes: 0 });

  return (
    <div style={s.wrap}>
      <SgsstTabs />
      <div style={s.head}>
        <div>
          <h1 style={s.h1}>Panel SG-SST</h1>
          <p style={s.sub}>Indicadores de seguridad y salud en el trabajo · {d?.empleados ?? '—'} trabajadores</p>
        </div>
        <select style={s.sel} value={anio} onChange={e => setAnio(Number(e.target.value))}>
          {[yNow, yNow - 1, yNow - 2].map(y => <option key={y} value={y}>{y}</option>)}
        </select>
      </div>

      <div style={s.tiles}>
        <Tile big={t.accidentes ?? 0} label="Accidentes de trabajo" c="#ef4444" />
        <Tile big={(t.incidentes ?? 0) + (t.casi_accidentes ?? 0)} label="Incidentes / casi-accidentes" c="#f59e0b" />
        <Tile big={t.dias_perdidos ?? 0} label="Días de incapacidad" c="#8b5cf6" />
        <Tile big={t.mortales ?? 0} label="Accidentes mortales" c="#dc2626" />
      </div>

      <div style={s.row2}>
        <div style={s.card}>
          <div style={s.cardTit}>Índices (Res. 0312)</div>
          <div style={s.indRow}><span>Índice de frecuencia (IF)</span><b style={s.indVal}>{ind.frecuencia ?? 0}</b></div>
          <div style={s.indRow}><span>Índice de severidad (IS)</span><b style={s.indVal}>{ind.severidad ?? 0}</b></div>
          <div style={s.indHint}>Base K=240.000 · HHT estimado {Number(ind.hht || 0).toLocaleString('es-CO')} h/año</div>
        </div>
        <div style={s.card}>
          <div style={s.cardTit}>Planes de acción</div>
          <div style={s.indRow}><span>Abiertas</span><b style={{ ...s.indVal, color: '#f59e0b' }}>{acc.abiertas ?? 0}</b></div>
          <div style={s.indRow}><span>Vencidas</span><b style={{ ...s.indVal, color: '#ef4444' }}>{acc.vencidas ?? 0}</b></div>
          <div style={s.indRow}><span>Cerradas</span><b style={{ ...s.indVal, color: '#10b981' }}>{acc.cerradas ?? 0}</b></div>
        </div>
        <div style={s.card}>
          <div style={s.cardTit}>Matriz de riesgos</div>
          <div style={s.indRow}><span>Riesgos identificados</span><b style={s.indVal}>{rie.total ?? 0}</b></div>
          <div style={s.indRow}><span>No aceptables (I / II)</span><b style={{ ...s.indVal, color: '#ef4444' }}>{rie.no_aceptables ?? 0}</b></div>
        </div>
      </div>

      <div style={s.row2}>
        <div style={s.card}>
          <div style={s.cardTit}>Operación</div>
          <div style={s.indRow}><span>Inspecciones</span><b style={s.indVal}>{op.inspecciones ?? 0}</b></div>
          <div style={s.indRow}><span>Cumplimiento promedio</span><b style={s.indVal}>{op.inspeccion_cumplimiento ?? 0}%</b></div>
          <div style={s.indRow}><span>Condiciones abiertas</span><b style={{ ...s.indVal, color: (op.condiciones_abiertas ? '#f59e0b' : '#f1f5f9') }}>{op.condiciones_abiertas ?? 0}</b></div>
        </div>
        <div style={s.card}>
          <div style={s.cardTit}>Capacitación</div>
          <div style={s.indRow}><span>Capacitaciones</span><b style={s.indVal}>{op.capacitaciones ?? 0}</b></div>
          <div style={s.indRow}><span>Horas de formación</span><b style={s.indVal}>{op.capacitacion_horas ?? 0}</b></div>
        </div>
        <div style={s.card}>
          <div style={s.cardTit}>Ausentismo</div>
          <div style={s.indRow}><span>Días perdidos</span><b style={s.indVal}>{ind.ausentismo_dias ?? 0}</b></div>
          <div style={s.indRow}><span>Tasa de ausentismo</span><b style={s.indVal}>{ind.ausentismo_tasa ?? 0}%</b></div>
        </div>
      </div>

      <div style={s.card}>
        <div style={s.cardTit}>Eventos por mes · {anio}</div>
        <div style={s.chart}>
          {mesData.map((m, i) => {
            const total = m.accidentes + m.incidentes;
            return (
              <div key={i} style={s.barCol} title={`${MESES[i]}: ${m.accidentes} acc · ${m.incidentes} inc`}>
                <div style={s.barStack}>
                  <div style={{ ...s.barSeg, background: '#ef4444', height: `${(m.accidentes / maxMes) * 100}%` }} />
                  <div style={{ ...s.barSeg, background: '#f59e0b', height: `${(m.incidentes / maxMes) * 100}%` }} />
                </div>
                <div style={s.barLbl}>{MESES[i]}</div>
                <div style={s.barNum}>{total || ''}</div>
              </div>
            );
          })}
        </div>
        <div style={s.legend}>
          <span style={s.legItem}><i style={{ ...s.legDot, background: '#ef4444' }} />Accidentes</span>
          <span style={s.legItem}><i style={{ ...s.legDot, background: '#f59e0b' }} />Incidentes / casi-accidentes</span>
        </div>
      </div>
    </div>
  );
}

const Tile = ({ big, label, c }) => (
  <div style={{ ...s.card, padding: '16px 18px' }}>
    <div style={{ fontSize: 30, fontWeight: 800, color: c, fontFamily: 'ui-monospace,monospace' }}>{big}</div>
    <div style={{ fontSize: 12.5, color: '#94a3b8', marginTop: 4 }}>{label}</div>
  </div>
);

const s = {
  wrap: { padding: 4 },
  head: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16, flexWrap: 'wrap', gap: 12 },
  h1: { color: '#f1f5f9', fontSize: 24, fontWeight: 700, margin: '0 0 4px' },
  sub: { color: '#64748b', fontSize: 14, margin: 0 },
  sel: { background: '#0f172a', border: '1px solid #334155', borderRadius: 8, padding: '8px 12px', color: '#f1f5f9', fontSize: 14 },
  tiles: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(180px,1fr))', gap: 12, marginBottom: 12 },
  row2: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(240px,1fr))', gap: 12, marginBottom: 12 },
  card: { background: '#1e293b', border: '1px solid #334155', borderRadius: 12, padding: 16 },
  cardTit: { color: '#e2e8f0', fontSize: 13, fontWeight: 700, marginBottom: 12, textTransform: 'uppercase', letterSpacing: .5 },
  indRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '6px 0', color: '#94a3b8', fontSize: 13, borderBottom: '1px solid #0f172a' },
  indVal: { fontFamily: 'ui-monospace,monospace', fontSize: 18, color: '#f1f5f9' },
  indHint: { color: '#64748b', fontSize: 11, marginTop: 8 },
  chart: { display: 'flex', alignItems: 'flex-end', gap: 6, height: 160, padding: '8px 0' },
  barCol: { flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', height: '100%', justifyContent: 'flex-end' },
  barStack: { width: '70%', maxWidth: 28, display: 'flex', flexDirection: 'column-reverse', flex: 1, justifyContent: 'flex-start', borderRadius: 4, overflow: 'hidden' },
  barSeg: { width: '100%', transition: 'height .3s' },
  barLbl: { fontSize: 10, color: '#64748b', marginTop: 5 },
  barNum: { fontSize: 11, color: '#94a3b8', fontWeight: 700, fontFamily: 'ui-monospace,monospace' },
  legend: { display: 'flex', gap: 18, marginTop: 8, fontSize: 12, color: '#94a3b8' },
  legItem: { display: 'inline-flex', alignItems: 'center', gap: 6 },
  legDot: { width: 11, height: 11, borderRadius: 3, display: 'inline-block' },
};
